import React from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

function Header() {
  return (
    <header className="header-bar">
      <div className="brand">Currency Hub</div>
      <nav className="nav-links">
        <NavLink className="nav-link" to="/home">
          Home
        </NavLink>
        <NavLink className="nav-link" to="/currency">
          Currency
        </NavLink>
        <NavLink className="nav-link" to="/signup">
          Sign Up
        </NavLink>
        <NavLink className="nav-link" to="/support">
          Support
        </NavLink>
      </nav>
    </header>
  );
}

export default Header